// 页面主要状态管理
const main = {
  state: {
    wxappid: process.env.WX_AppId,
    show_wwlogin: process.env.SHOW_WWLOGIN,
    mapCitys: [
      { code: '110100', name: '北京', group: 'B' },
      { code: '510100', name: '成都', group: 'C' },
      { code: '440300', name: '深圳', group: 'S' },
      { code: '330100', name: '杭州', group: 'H' },
      { code: '350200', name: '厦门', group: 'X' },
      { code: '810000', name: '香港', group: 'X' },
      { code: '370200', name: '青岛', group: 'Q' },
      { code: '420100', name: '武汉', group: 'W' },
      { code: '320100', name: '南京', group: 'N' },
      { code: '330200', name: '宁波', group: 'N' },
      { code: '440100', name: '广州', group: 'G' },
      { code: '120100', name: '天津', group: 'T' },
      { code: '610100', name: '西安', group: 'X' },
      { code: '500100', name: '重庆', group: 'C' },
      { code: '430100', name: '长沙', group: 'C' },
      { code: '220100', name: '长春', group: 'C' },
      { code: '530100', name: '昆明', group: 'K' },
      { code: '210100', name: '沈阳', group: 'S' },
      { code: '310100', name: '上海', group: 'S' },
      { code: '210200', name: '大连', group: 'D' },
      { code: '320500', name: '苏州', group: 'S' },
      { code: '710001', name: '台北', group: 'T' },
      { code: '320200', name: '无锡', group: 'W' },
      { code: '340100', name: '合肥', group: 'H' },
      { code: '410100', name: '郑州', group: 'Z' },
      { code: '130100', name: '石家庄', group: 'S' },
      { code: '710002', name: '高雄', group: 'G' },
      { code: '150100', name: '呼和浩特', group: 'H' },
      { code: '330300', name: '温州', group: 'W' },
      { code: '230100', name: '哈尔滨', group: 'H' },
      { code: '320300', name: '徐州', group: 'X' },
      { code: '320400', name: '常州', group: 'C' },
      { code: '450100', name: '南宁', group: 'N' },
      { code: '520100', name: '贵阳', group: 'G' },
      { code: '360100', name: '南昌', group: 'N' },
      { code: '350100', name: '福州', group: 'F' },
      { code: '441900', name: '东莞', group: 'D' },
      { code: '620100', name: '兰州', group: 'L' },
      { code: '140100', name: '太原', group: 'T' },
      { code: '370100', name: '济南', group: 'J' },
      { code: '650100', name: '乌鲁木齐', group: 'W' },
      { code: '820000', name: '澳门', group: 'A' }
    ]
  }
}

export default main
